import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90f89e16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xag-page__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_contact_us = _resolveComponent("app-contact-us")!
  const _component_van_action_bar_button = _resolveComponent("van-action-bar-button")!
  const _component_van_action_bar = _resolveComponent("van-action-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_app_contact_us, null, null, 512), [
      [_vShow, !_ctx.isMiniProgram]
    ]),
    _createVNode(_component_van_action_bar, {
      "safe-area-inset-bottom": false,
      style: {"position":"relative","height":"58px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_action_bar_button, {
          class: "custom-button",
          style: _normalizeStyle({ color: _ctx.isCanClick ? '#fff' : '#bfbfbf' }),
          type: _ctx.isCanClick ? 'success' : 'info',
          text: _ctx.title,
          onClick: _ctx.onClickButton
        }, null, 8, ["style", "type", "text", "onClick"])
      ]),
      _: 1
    })
  ]))
}